import React, { Component } from 'react';
import cookie from 'react-cookies';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';
import {hideNav, showLoader, hideLoader, configureMoment} from '../../../functions';
import Moment from 'moment';
import $ from 'jquery';
import SectorFichaProducto from './sectorFichaProducto';
import AdmPreciosFob from './../Pagina/Modulos/PreciosFob/preciosFob';

export default class FichaPartida extends Component {
    state = {
        fichasProductos: [],
        sector: "0",
        pagina: 1,
        totalPages: 0
    }


    filtroSector(value)
    {
        this.setState({
            sector: (value == null)?"0":value.value
        });
    }

    EstadoText(value)
    {
        switch(value)
        {
            case "0": return <span className="label label-primary">BORRADOR</span>;
            case "1": return <span className="label label-info" style={{background: "#44AA44"}}>PUBLICADO</span>;
            default: break;
        }
    }

    PDFFichaTecnica(value)
    {
        switch(value)
        {
            case null: break;
            default: return <a href={ value } className="btnListIcon" target="_blank" />;
        } 
    }

    render() {
        configureMoment(Moment);

        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de configuración general
                        </a>
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Ficha Partidas</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Ficha de Partida
                </div>
                <div className="divSector_ProductoPanel">
                    <div className="divCatAnadir_Panel">
                    <div className="body-container container-fluid">
                        <div className="input-group">
                            <div className="input-group col-sm-4">
                            <i className="recursos__search-icon fas fa-search"></i>
                            <input className="recursos__search-form-control form-control input-lg" type="text" placeholder="Encontrar ficha Partida..." id="busqueda" onKeyDown={this._handleKeyDown}/>
                            </div>
                            {/* <div className='input-group-btn col-sm-4'>
                                <SectorFichaProducto
                                    onChange={(value) => this.filtroSector(value)}
                                />
                            </div> */}
                            <div className='input-group-btn'>
                            <a href="#" className="btn btn-primary btn-primary__submit noneEvent" onClick={(event) => this.callFunctionBuscar(event)}>
                                <i className="fas fa-search" style={{ marginRight: "8px" }} />
                                BUSCAR
                                </a>
                            </div>
                            {/* &nbsp;&nbsp;
                            <div className='input-group-btn'>
                            <a href="#" className="btn btn-success btn-primary__submit noneEvent" onClick={() => this.addFichaProducto()}>
                                <i className="fas fa-save" style={{ marginRight: "8px" }} />
                                NUEVO
                            </a>
                            </div> */}
                        </div>
                    </div>
                    </div>
                    <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <th>N°</th>
                                <th>Código</th>
                                <th>Descripción de partida</th>
                                <th>Producto asociado</th>
                                <th>FOB (reciente)</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                                {
                                    this.state.fichasProductos.length > 0 ? 
                                    
                                    this.state.fichasProductos && this.state.fichasProductos.map((item, index) => (
                                        <tr key={`pais-codigo-${item.productoCodigo}`}>
                                            <td>{(index + 1) + ((this.state.pagina - 1) * 10)}</td>
                                            <td>{item.part_Codigo}</td>
                                            <td>{item.part_Descripcion}</td>
                                            <td>{item.part_Producto}</td>
                                            <td>
                                                { item.part_UltimoAnio > 0 &&
                                                    <React.Fragment>
                                                        {item.part_FobUltimoAnio}<br/>{item.part_UltimoAnio}
                                                    </React.Fragment>
                                                }
                                            </td>    
                                            {/* <td>{item.part_EstadoPublico=="1"?"Si" :"No"}</td> */}
                                            <td>{this.EstadoText(item.part_EstadoPublico)}</td> 
                                            <td>
                                                <div className="divBtnAcciones px-3" style={{ 'width': 60 }}>
                                                    <button
                                                     type="button"  
                                                     className="btn btn-primary btn-sm btn-primary__tool" 
                                                     onClick={(event) => this.editFichaProducto(item.part_Id)}
                                                     >
                                                        <i className="fas fa-pen fa-sm"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    (
                                        <tr>
                                            <td colSpan="5" className="tdSinResultados">
                                                No se encontró resultados.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    {this.paginationTable()}
                    <div className="clear" />
                </div>
            </div>
        )
    }

    irMantCertificados(event, id){
        event.preventDefault();

        this.props.history.push({
            pathname: '/ficha-producto-certificados/' + id
        });
    }

    irMantPartidas(event, id){
        event.preventDefault();

        this.props.history.push({
            pathname: '/ficha-producto-partidas/' + id
        });
    }

    ShowPaginationFive(pagina)
	{
        if(this.state.totalPages == 1 || this.state.totalPages == 0){
            return;
        }
        
		$(".divPaginador a.active").removeClass("active");
		$(".divPaginador a:eq("+pagina+")").next().addClass("active");
		
		$(".divPaginador .pageItem").hide();
		
		let id = $(".divPaginador a.active").prop("id");
        let ItemPage = parseInt(id.replace('paginado-', ''));
        
		if(ItemPage < 4)
		{
			$(".divPaginador .pageItem").slice(0,5).show();
		}
		else if(ItemPage < 5)
		{
			$(".divPaginador .pageItem").slice(1,6).show();
		}
		else if(ItemPage < 6)
		{
			$(".divPaginador .pageItem").slice(2,7).show();
		}
		else if(ItemPage >= 6)
		{
			$(".divPaginador .pageItem.active").prev().prev().show();
			$(".divPaginador .pageItem.active").prev().show();
			$(".divPaginador .pageItem.active").show();
			$(".divPaginador .pageItem.active").next().show();
			$(".divPaginador .pageItem.active").next().next().show();
		}
		
		if(!$(".pageItem.active").next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().show()
		  }
		}
		if(!$(".pageItem.active").next().next().hasClass("pageItem")){
		  if($(".pageItem.active").prev().prev().prev().prev().hasClass("pageItem")){
			  $(".pageItem.active").prev().prev().prev().prev().show()
		  }
		}
    }

    executePaginationPrev(e)
	{
		if(!$(".divPaginador a.active").prev().hasClass("btnPrevPaginador"))
		{
            let id = $(".divPaginador a.active").prop("id");
            let itemPage = parseInt(id.replace('paginado-', '')) - 1;

			this.executePagination(itemPage, e);
		}
	}
	
	executePaginationNext(e)
	{
		if(!$(".divPaginador a.active").next().hasClass("btnNextPaginador"))
		{
            let id = $(".divPaginador a.active").prop("id");
            let itemPage = parseInt(id.replace('paginado-', '')) + 1;
            
			this.executePagination(itemPage, e);
		}
	}

    executePagination(page)
    {
        const url = this.getURL(page, this.state.sector);

        for(let index=0; index < this.state.totalPages+2; index++)
        {
			if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }
        
		if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
        }

        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            
            this.setState({ 
                fichasProductos: data.result.data.Data, 
                pagina: page,
                totalPages: data.result.data.TotalPages
            });
            this.ShowPaginationFive(page-1);
        })
        .catch(error => {
            toast.error('Error al listar');
        });
    }

    paginationTable()
    {
        const options = [];

        if(this.state.totalPages == 1 || this.state.totalPages == 0){
            return;
        }

        options.push(<a className="btnPrevPaginador" id={`paginado-prev`} key={`paginado-prev`} onClick={() => this.executePaginationPrev()}></a>);
            
        for(let index=1; index <= this.state.totalPages; index++){
            options.push(<a className="pageItem" id={`paginado-${index.toString()}`} key={`paginado-${index.toString()}`} onClick={() => this.executePagination(index)}> {index} </a>);
        }
     
        options.push(<a className="btnNextPaginador" id={`paginado-next`} key={`paginado-next`} onClick={() => this.executePaginationNext()}></a>)

        return (
            <div className="divPaginador">
                {options}
            </div>
        );
    }

    // addFichaProducto(){
    //     this.props.history.push({
    //         pathname: '/agregar-ficha-producto'
    //     });
    // }

    editFichaProducto(id){
        this.props.history.push({
            pathname: '/editar-ficha-partida/' + id
        });
    }

    actualizarEstado(fichaProducto, event){
        event.preventDefault();

        const url = `${API_URL}FichaPartidaUX/ActualizarEstado`;

        fichaProducto["UsuarioEdicion"] = cookie.load('user').nUsuCodigo;
        
        axios.post(url, JSON.stringify(JSON.stringify(fichaProducto)),
        { 
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }).then((data) => {     
            if (data.data.result.status)
            {
                setTimeout(() => { 
                    this.executePagination(this.state.pagina);
                }, 500);  
            }
        }).catch((error)=> {
            
        });  
    }
    
    eliminarRegistro(fichaProducto, event) {
        event.preventDefault();

        const url = `${API_URL}FichaPartidaUX/Eliminar`;

        fichaProducto["UsuarioEliminacion"] = cookie.load('user').nUsuCodigo;

        axios.post(url, JSON.stringify(JSON.stringify(fichaProducto)),
        { 
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8' ,
                    'Accept': 'application/json'
        }
        }).then((data)=> {
            if (data.data.result.status)
            {
                setTimeout(() => { 
                    this.executePagination(this.state.pagina);
                }, 500);  
            }
        }).catch((error)=> {
        });
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callFunctionBuscar(e);
        }
    }

    callFunctionBuscar = (event) => {
        showLoader();

        const url = this.getURL(1, this.state.sector);
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            hideLoader();
           
            this.setState({ 
                fichasProductos: data.result.data.Data, 
                pagina: 1,
                totalPages: data.result.data.TotalPages
            });
            this.ShowPaginationFive(0);
        })
        .catch(error => {
            hideLoader();
            toast.error('Error al listar');
        });
    }

    getURL(pageRequest, sectorCodigo){
        return `${API_URL}FichaPartidaUX/Listar?page=${pageRequest}&sector=${sectorCodigo}&busqueda=` + document.getElementById('busqueda').value;
    }

    componentDidMount(){
        showLoader();

        const url = this.getURL(1, 0);
        axios.get(url)
            .then(response => response.data)
            .then((data) => {
                hideLoader();
                
                this.setState({ 
                    fichasProductos: data.result.data.Data, 
                    pagina: 1,
                    totalPages: data.result.data.TotalPages
                });
                this.ShowPaginationFive(0);
            })
            .catch(error => {
                hideLoader();
                toast.error('Error al listar');
            });
    }
}
